import './ntai.css'
import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../../Components/AuthContext/AuthContext'
import { get, post } from '../../Services/api';
import sendImage from '../../resources/send.svg'; // Adjust the path to your image
import { Link } from 'react-router-dom';
import img1 from '../../resources/ntai_logo.svg'
import { IoMdMenu } from "react-icons/io";
import { isToday, isWithinInterval, subDays } from 'date-fns'; // Using date-fns for date utilities
import { useParams } from 'react-router-dom';
import yyyy_mm_dd_date_format from '../../Utility/yyyy_mm_dd_date_format';
import { FormGroup, Checkbox, TextField, FormControlLabel, FormControl } from '@mui/material';
import { useSearchParams } from "react-router-dom";
import { getAuth } from 'firebase/auth';

const auth = getAuth();
const env = process.env.NODE_ENV
const devApiUrl = process.env.REACT_APP_PROXY_DEVELOPMENT;
const prodApiUrl = process.env.REACT_APP_PROXY_PRODUCTION;
const stgApiUrl = process.env.REACT_APP_PROXY_STG;

// Create an instance of axios with default settings
const baseURL = (env === "development") ? devApiUrl : prodApiUrl;
const apiUrl = `${baseURL}api/nutritionist-ai/nutritionist-chat`;

function NutritionistAI() {
    const today_date = yyyy_mm_dd_date_format({})
    const change_request = {
        weight: 'user_update_weight',
        activity_level: 'user_update_activity_level',
        goal: 'user_update_goal',
        height: 'user_update_height',
        tdee: 'user_update_tdee',
        suggested_tdee: 'suggested_tdee'
    }

    const [pastChats, setPastChats] = useState(null);
    const [messages, setMessages] = useState([]);
    const [userInput, setUserInput] = useState('');
    const [aiResponse, setAIReponse] = useState('');
    const { currentUser, userInfo } = useAuth();
    const [chatID, setchatID] = useState(null);
    const [responding, setResponding] = useState(false);
    const [userSetMenu, setUserSetMenu] = useState(false);

    const [configs, setConfigs] = useState()

    const [weight, setWeight] = useState()
    const [weightUnitChange, setWeightUnitChange] = useState('')
    const [weightChange, setWeightChange] = useState()
    const [activityLevel, setActivityLevel] = useState()
    const [suggestedTdee, setSuggestedTdee] = useState()
    const [height, setHeight] = useState()
    const [heightFeet, setHeightFeet] = useState()
    const [heightInches, setHeightInches] = useState()
    const [heightCm, setHeightCm] = useState()
    const [heightUnitChange, setHeightUnitChange] = useState('')
    const [inputTdee, setInputTdee] = useState()
    const [selecteActivityLevel, setSelectedActivityLevel] = useState()
    const [selecteGoals, setSelectedGoals] = useState([])

    const scrollableDivRef = useRef(null);
    const hasRunAlready = useRef(false); // Create a ref to track if the effect has run
    const today = new Date();

    const { question } = useParams();


    const [searchParams] = useSearchParams();
    const { ALERT_ID } = Object.fromEntries([...searchParams]);


    useEffect(() => {
        // Scroll to the bottom whenever content changes
        const scrollDiv = scrollableDivRef.current;
        scrollDiv.scrollTop = scrollDiv.scrollHeight;
    }, [messages, aiResponse]); // Dependency array with content

    useEffect(() => {
        pastChatHandeling()
    }, [chatID])

    useEffect(() => {

        function handleResize() {
            if (window.innerWidth >= 1250) {
                document.getElementById('ntai-conversation-list').style.display = 'flex';
                setUserSetMenu(false)
            } else {
                if (!userSetMenu) {
                    document.getElementById('ntai-conversation-list').style.display = 'none';
                }
            }
        }

        window.addEventListener('resize', handleResize);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [userSetMenu]);

    useEffect(() => {
        setNtaiDivHeight()
    }, [userInfo])

    useEffect(() => {
        if ((ALERT_ID != undefined || question !== undefined) && !hasRunAlready.current) {
            sendMessage(question, ALERT_ID ? true : false)
            hasRunAlready.current = true
        }
    }, [])

    function toggleChatsHistoryMenu() {
        const conv_list = document.getElementById('ntai-conversation-list')
        conv_list.style.display = conv_list.style.display == 'flex' ? 'none' : 'flex'
        setUserSetMenu(true);
    }

    function setNtaiDivHeight() {
        const ntaiParentDiv = document.getElementById('ntai-chat-app');
        // if (ntaiParentDiv && userInfo) {
        //     ntaiParentDiv.style.height = userInfo.active_subscription ? 'calc(100vh - 80px)' : 'calc(100vh - 132px)';
        // }
    }

    async function is_authorized_chat() {
        const isAuthorized = await get('api/nutritionist-ai/ntai_is_authorized_chat', {
            user_id: currentUser.uid,
            chat_id: chatID
        });
        return isAuthorized;
    }

    async function getPreviousChats() {
        const previous_chats = await get('api/nutritionist-ai/get_ntai_chats', { user_id: currentUser.uid, });

        categorizeChats(previous_chats)
    }

    const categorizeChats = (chats) => {
        if (chats) {

            const categories = {
                today: [],
                past7Days: [],
                past30Days: [],
            };

            chats.forEach(chat => {
                const chatDate = new Date(chat.update_date);

                if (isToday(chatDate)) {
                    categories.today.push(chat);
                } else if (isWithinInterval(chatDate, {
                    start: subDays(today, 7),
                    end: today,
                })) {
                    categories.past7Days.push(chat);
                } else if (isWithinInterval(chatDate, {
                    start: subDays(today, 30),
                    end: today,
                })) {
                    categories.past30Days.push(chat);
                }
            });

            setPastChats(categories)
        }

    };


    async function pastChatHandeling() {
        // get chat history
        await getPreviousChats()

        if (chatID) {
            if (await is_authorized_chat()) {
                const chat_texts = await get('api/nutritionist-ai/get_ntai_chat_texts', { chat_id: chatID });
                const stringifiedChatArray = chat_texts.map(obj => {
                    // // replace any update string with empty string
                    // const matchedKey = Object.keys(change_request).find(key => {
                    //     return obj.content && obj.content.includes(change_request[key]);
                    // });
                    // // If a match is found, call the function
                    // if (matchedKey)
                    //     obj.content = ' '

                    return JSON.stringify(obj)
                });
                setMessages(stringifiedChatArray)
            } else {
                window.location.href = '/ntai';
            }
        } else {
            setMessages([])
        }

    }

    const handleUserInput = (event) => {
        setUserInput(event.target.value);
    };

    function disableSendButton(disable) {
        const sendButton = document.getElementById("ntai-send-button");
        if (sendButton) {
            sendButton.disabled = disable;
        }
    }

    const sendMessage = async (question, alert_request) => {
        // set suggested tdee to null on chat
        setSuggestedTdee()

        const messages_tmp = [...messages]

        // Change last element of AI response if update text
        const lastMessageString = messages_tmp[messages_tmp.length - 1];
        if (lastMessageString) {
            // Parse the JSON string
            const lastMessageJson = JSON.parse(lastMessageString);
            // Check if the `content` includes any value from `change_request`
            const matchedKey = Object.keys(change_request).find(key => {
                return lastMessageJson.content && lastMessageJson.content.includes(change_request[key]);
            });
            // If a match is found, call the function
            if (matchedKey)
                lastMessageJson.content = ' '
            messages_tmp[messages_tmp.length - 1] = JSON.stringify(lastMessageJson);
        }


        if (userInput?.trim() === '' && question?.trim() === '' && !alert_request) return;

        try {
            let messgaesToSend = { role: 'user', content: userInput ? userInput : question }
            setMessages([...messages, JSON.stringify(messgaesToSend)]);
            // Remove user's input and make send button disabled till this is processed
            setUserInput('');
            disableSendButton(true)
            const params = {
                user_id: currentUser.uid,
                text: JSON.stringify(messgaesToSend),
                alert_id: alert_request ? ALERT_ID : null,
                chat_id: chatID
            };

            const queryString = new URLSearchParams(params).toString();
            const url = `${apiUrl}?${queryString}`;
            const idToken = await auth.currentUser?.getIdToken();

            try {
                const response = await fetch(url, {
                    credentials: 'include',
                    headers: {
                        'Authorization': idToken ? `Bearer ${idToken}` : undefined,
                        'Content-Type': 'application/json', // Add other headers as needed
                    },
                });

                if (!response.body) {
                    throw new Error('ReadableStream not supported.');
                }

                const reader = response.body.getReader();
                let content = '';
                let newChatId
                const readStream = async () => {
                    try {
                        let isFirstChunk = true;
                        setResponding(true)
                        while (true) {

                            const { done, value } = await reader.read();
                            if (done) break;

                            const textChunk = new TextDecoder().decode(value);
                            let aiResponsePart = ""
                            if (isFirstChunk) {
                                isFirstChunk = false;
                                const endOfJson = textChunk.indexOf('}') + 1;
                                const jsonPart = textChunk.substring(0, endOfJson);
                                aiResponsePart = textChunk.substring(endOfJson);
                                content += aiResponsePart

                                try {
                                    const json = JSON.parse(jsonPart);
                                    newChatId = json.new_chat_id;

                                    setchatID(newChatId)
                                } catch (error) {
                                    console.error('Error parsing initial JSON:', error);
                                }
                            } else {
                                aiResponsePart = textChunk;
                                content += aiResponsePart
                            }
                            setAIReponse((prev) => prev + aiResponsePart);
                        }

                    } catch (error) {
                        console.error('Error reading stream:', error);
                    }
                };

                await readStream();

                await getUpdatedChat(newChatId)
                // setMessages((prevMessages) => [...prevMessages, JSON.stringify({ role: 'assistant', content })]);

                setAIReponse('');
                setResponding(false)
                disableSendButton(false)
                await getPreviousChats()
                if (question) {
                    window.history.pushState({}, '', '/ntai');
                }
            } catch (error) {
                console.error('Error sending message:', error);
            }

        } catch (error) {
            console.error('Error:', error);
            // Handle error (e.g., show error message to the user)
        }
    };


    async function getUpdatedChat(newChatId) {
        const chat_texts = await get('/api/nutritionist-ai/get_ntai_chat_texts', { chat_id: newChatId ? newChatId : chatID });
        const stringifiedChatArray = chat_texts.map(obj => {
            return JSON.stringify(obj)
        });
        setMessages(stringifiedChatArray)
    }

    function selectChat(id) {
        if (window.innerWidth < 1250) {
            toggleChatsHistoryMenu()
        }
        setchatID(id)
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            sendMessage();
        }
    };

    function formatText(text) {
        if (text) {
            // Split text by lines (newlines)
            const lines = text.split('\n');

            // Arrays to hold formatted content
            const content = [];

            lines.forEach((line, index) => {
                // Check if the line starts with a number followed by a period (e.g., "1. ")
                const match = line.match(/^(\d+)\.\s+(.*)$/);

                if (match) {
                    // Extract the part after the number and period
                    const formattedLine = match[2].replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
                    content.push(<li key={index} dangerouslySetInnerHTML={{ __html: formattedLine }} />);
                } else {
                    // If it's not a list item, treat it as normal text (paragraph)
                    const formattedLine = line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
                    if (formattedLine.trim()) {
                        content.push(<p className='font_size_16' key={index} dangerouslySetInnerHTML={{ __html: formattedLine }} />);
                    }
                }
            });

            // Separate list items to wrap in <ol>
            const listItems = content.filter(item => item.type === 'li');
            const paragraphs = content.filter(item => item.type === 'p');
            var firstListItem = true;

            // Render content while maintaining the original order
            return (
                <div>
                    {content.map((item, index) => {
                        if (item.type === 'li') {
                            var tmp = firstListItem
                            firstListItem = false;
                            return tmp === true ? <span key={index}> <br />{item} <br /></span> : <span key={index}> {item} <br /></span>; // Render list items directly
                        } else {
                            return <span key={index}>{item}</span>; // Render paragraphs directly
                        }
                    })}
                </div>
            );
        }
    }

    useEffect(() => {
        // get user info
        get_user_info()

        // get config questions and options
        getConfigQuestionsOptions()
    }, [])


    async function getConfigQuestionsOptions() {
        const result_configs = await get("/api/user-config/get-questions-and-options")
        setConfigs(result_configs)
    }

    async function get_user_info() {
        const weight = await get('/api/analytics/get-weight-on-day?user_id=' + currentUser.uid + '&date=' + today_date)
        setWeight(weight)

        const activity_level = await get('/api/analytics/get-user-activity-level?user_id=' + currentUser.uid)
        setActivityLevel(activity_level)
    }

    async function updateWeight() {
        const old_set_weight = weight.previous_weight
        const old_set_weight_unit = weight.weight_unit
        await post('/api/analytics/update-weight', {
            user_id: currentUser.uid,
            weight: weightChange,
            unit: weightUnitChange ? weightUnitChange : weight.weight_unit,
            date: today_date
        })
        // reset weight factors
        setWeightChange()
        setWeightUnitChange()


        // get suggested tdee
        const suggested_tdee = await get('/api/analytics/get-suggested-tdee', {
            user_id: currentUser.uid,
            today_date: today_date
        })
        // reset weight factors
        setSuggestedTdee(suggested_tdee.tdee)

        // Get user info
        await get_user_info()

        // update ai response chat string
        await updateAIChatResponse('weight', weightChange, weightUnitChange ? weightUnitChange : weight.weight_unit, old_set_weight, old_set_weight_unit)
    }


    async function updateTdee(update_tdee) {
        // set tdee
        await post('/api/analytics/update-tdee-by-user', {
            user_id: currentUser.uid,
            tdee: update_tdee,
            today_date: today_date
        })

        // Get user info
        await get_user_info()

        // update ai response chat string
        await updateAIChatResponse('daily calorie intake', update_tdee, null, null, null, true)

        // empty suggested tdee
        setSuggestedTdee()
    }

    async function updateActivityLevel() {
        // set tdee
        await post('/api/analytics/update-activity-level-by-user', {
            user_id: currentUser.uid,
            activity_level: selecteActivityLevel,
            today_date: today_date
        })

        // Get user info
        await get_user_info()

        const activity_level_string = configs.filter((i) => i.id === 12)[0].options.find((c) => selecteActivityLevel == c.id);

        // update ai response chat string
        await updateAIChatResponse('activity level', activity_level_string.text, null, null, null, true)

        // empty suggested tdee
        setSuggestedTdee()
    }


    async function updateGoals() {
        // set tdee
        await post('/api/analytics/update-goals-by-user', {
            user_id: currentUser.uid,
            goals: selecteGoals
        })

        // Get user info
        await get_user_info()

        // update ai response chat string
        await updateAIChatResponse('health goals', null, null, null, null, true)

        // empty suggested tdee
        setSuggestedTdee()
    }


    async function updateHeight() {
        let height_tmp, height_string
        if (heightUnitChange == 'metric') {
            height_tmp = heightCm
            height_string = heightCm + ' cm'
        } else {
            height_tmp = parseInt((heightFeet + heightInches / 12) * 30.48)
            height_string = heightFeet + "'" + heightInches + '"'
        }
        // set height
        await post('/api/user-config/update-height', {
            user_id: currentUser.uid,
            height: height_tmp
        })

        // get suggested tdee
        const suggested_tdee = await get('/api/analytics/get-suggested-tdee', {
            user_id: currentUser.uid,
            today_date: today_date
        })
        // reset weight factors
        setSuggestedTdee(suggested_tdee.tdee)

        // Get user info
        await get_user_info()

        // update ai response chat string
        await updateAIChatResponse('height', height_string)
    }


    async function updateAIChatResponse(updated_item, p_one, p_two, old_p_one, old_p_two, new_message) {
        // text
        const text = "Your " + updated_item + (p_one ? (" is now set to " + p_one + (p_two ? (' ' + p_two) : '') + (old_p_one ? (' from the previous ' + old_p_one + (old_p_two ? (' ' + old_p_two) : '')) : '') + '.') : ' has been update.')

        if (new_message) {
            // insert into chat
            await post('/api/nutritionist-ai/insert-nutritionist-chat', {
                content: text,
                role: 'assistant',
                chat_id: chatID
            })
        } else {
            const last_ai_response_string = messages[messages.length - 1]
            const last_ai_response_json = JSON.parse(last_ai_response_string)
            // update chat
            await post('/api/nutritionist-ai/update-nutritionist-chat', {
                text: text,
                chat_id: chatID,
                message_id: last_ai_response_json.id
            })
        }

        // get updated chat
        await getUpdatedChat()
    }

    function null_chat(index) {
        return (
            <div key={index} className={`ntai-message assistant flex flex_column gap_20`}>
                {/*  */}
            </div>
        )
    }

    return (
        <div id='ntai-chat-app' className="ntai-chat-app">
            <div className="ntai-conversation-list" id='ntai-conversation-list'>
                <div className='ntai-conversation-list-header font_family_inter font_weight_600  font_size_14'>
                    <Link to='/' style={{ textDecoration: 'none' }} className='gray_scale_3 font_weight_400' >Dashboard</Link>
                    <p>{'>'}</p>
                    <p>{"Nutritionist AI"}</p>
                </div>

                <button className='gray_gradient green_1 ntai_new_chat_button font_size_14 flex align_center justify_center gap_6' onClick={() => selectChat(null)}>
                    <p className='font_size_20'>+</p>
                    <p>New Chat</p>
                </button>
                {
                    pastChats && <ul id='ntai-conversation-list-ul'>
                        {/* Render "Today" Chats */}
                        {pastChats.today.length > 0 && (
                            <>
                                <li id="ntai_prev_chats_header_today" className='font_weight_600 font_family_inter font_size_14'>Today</li>
                                {pastChats.today.map((conv, index) => (
                                    <div key={index}>
                                        <li className='font_weight_400 font_family_inter' key={index} onClick={() => selectChat(conv.id)}>
                                            {conv.title}
                                        </li>
                                        {/* <hr /> */}
                                    </div>
                                ))}
                            </>
                        )}

                        {/* Render "Past 7 Days" Chats */}
                        {pastChats.past7Days.length > 0 && (
                            <>
                                <li id="ntai_prev_chats_header_7days" className='font_weight_600 font_family_inter font_size_14'>Past 7 Days</li>
                                {pastChats.past7Days.map((conv, index) => (
                                    <div key={index}>
                                        <li className='font_weight_400 font_family_inter' key={index} onClick={() => selectChat(conv.id)}>
                                            {conv.title}
                                        </li>
                                    </div>
                                ))}
                            </>
                        )}

                        {/* Render "Past 30 Days" Chats */}
                        {pastChats.past30Days.length > 0 && (
                            <>
                                <li id="ntai_prev_chats_header_30days" className='font_weight_600 font_family_inter font_size_14'>Past 30 Days</li>
                                {pastChats.past30Days.map((conv, index) => (
                                    <div key={index}>
                                        <li className='font_weight_400 font_family_inter' key={index} onClick={() => selectChat(conv.id)}>
                                            {conv.title}
                                        </li>
                                    </div>

                                ))}
                            </>
                        )}
                    </ul>
                }

            </div>

            <div className="ntai-chat-container">

                <div className="ntai-chat-history" ref={scrollableDivRef}>
                    <div className='ntai-chat-history-header'>
                        <button className='ntai-chat-history-header-button' onClick={toggleChatsHistoryMenu}>
                            <IoMdMenu size={20} color='#235539' />
                        </button>
                        <div className='ntai-chat-history-header-text'>
                            <p className='green_gradient_p font_weight_600 font_size_14'>
                                Nutritionist AI
                            </p>
                            <img className="search-icon" alt="" src={img1} />
                        </div>
                    </div>

                    <div className='ntai-chat-history-messages' >
                        {messages.map((msg, index) => {
                            // Weight Update
                            if (JSON.parse(msg).role == 'assistant' && JSON.parse(msg).content.includes(change_request.weight))
                                if (index == messages.length - 1)
                                    return (
                                        <div key={index} className={`ntai-message assistant flex flex_column gap_20`}>
                                            <p className='font_weight_600 font_size_18'>What should I set your weight to?</p>

                                            <div className='flex gap_10 align_center'>
                                                <input type="number" value={weightChange ? parseInt(weightChange) : null}
                                                    onChange={(e) => setWeightChange(!e.target.value || e.target.value < 0 ? 0 : (e.target.value < 1000 ? e.target.value : 999))}
                                                    style={{ width: `3ch` }}
                                                    placeholder={parseInt(weight.calculate_current_weight)}
                                                    className='analytics-weight-set-input font_family_ovo no_margin analytics-current-weight-p' />

                                                <select onChange={(e) => setWeightUnitChange(e.target.value)} className='analytics-weight-unit-select gray_gradient font_size_18 font_family_inter'>
                                                    <option value='lbs' selected={weight.weight_unit == 'lbs'}>lbs</option>
                                                    <option value='kg' selected={weight.weight_unit == 'kg'}>kg</option>
                                                </select>

                                                {weightChange ?
                                                    <div className='flex gap_8 align_center'>
                                                        <div></div>
                                                        <button onClick={updateWeight} className="analytics-weight-edit-save green_gradient white font_weight_600 cursor_pointer">Save</button>
                                                    </div> : null}
                                            </div>
                                        </div>
                                    )
                                else return null_chat(index)

                            // Height Update
                            else if (JSON.parse(msg).role == 'assistant' && JSON.parse(msg).content.includes(change_request.height)) {
                                if (index == messages.length - 1)
                                    return (
                                        <div key={index} className={`ntai-message assistant flex flex_column gap_20`}>
                                            <p className='font_weight_600 font_size_18'>What should I set your height to?</p>

                                            <div className='flex align_center gap_16'>
                                                {heightUnitChange == 'metric' ?
                                                    <TextField
                                                        fullWidth
                                                        label={'Height (cm)'}
                                                        type="number"
                                                        value={heightCm}
                                                        onChange={(e) => { setHeightCm(e.target.value >= 1 ? (e.target.value < 300 ? parseInt(e.target.value) : 300) : null) }}
                                                        margin="normal"
                                                        sx={{
                                                            '& .MuiInputLabel-root': {
                                                                color: 'gray',
                                                                '&.Mui-focused': {
                                                                    color: '#1F2933',
                                                                },
                                                            },
                                                            '& .MuiOutlinedInput-root': {
                                                                '& fieldset': {
                                                                    borderColor: '#82BD9C', // Default border color
                                                                },
                                                                '&:hover fieldset': {
                                                                    borderColor: '#299257', // Border color on hover
                                                                },
                                                                '&.Mui-focused fieldset': {
                                                                    borderColor: '#299257', // Border color when focused
                                                                },
                                                            },
                                                        }}
                                                    />

                                                    :

                                                    <div className='flex align_center gap_16'>
                                                        <TextField
                                                            label="Feet"
                                                            type="number"
                                                            value={heightFeet}
                                                            onChange={(e) => { setHeightFeet(e.target.value >= 1 ? (e.target.value < 9 ? parseInt(e.target.value) : 9) : null) }}
                                                            margin="normal"
                                                            sx={{
                                                                '& .MuiInputLabel-root': {
                                                                    color: 'gray',
                                                                    '&.Mui-focused': {
                                                                        color: '#1F2933',
                                                                    },
                                                                },
                                                                '& .MuiOutlinedInput-root': {
                                                                    '& fieldset': {
                                                                        borderColor: '#82BD9C', // Default border color
                                                                    },
                                                                    '&:hover fieldset': {
                                                                        borderColor: '#299257', // Border color on hover
                                                                    },
                                                                    '&.Mui-focused fieldset': {
                                                                        borderColor: '#299257', // Border color when focused
                                                                    },
                                                                },
                                                            }}
                                                        />
                                                        <TextField
                                                            label="Inches"
                                                            type="number"
                                                            value={heightInches}
                                                            onChange={(e) => { setHeightInches(e.target.value >= 1 ? (e.target.value < 12 ? parseInt(e.target.value) : 11) : null) }}
                                                            margin="normal"
                                                            sx={{
                                                                '& .MuiInputLabel-root': {
                                                                    color: 'gray',
                                                                    '&.Mui-focused': {
                                                                        color: '#1F2933',
                                                                    },
                                                                },
                                                                '& .MuiOutlinedInput-root': {
                                                                    '& fieldset': {
                                                                        borderColor: '#82BD9C', // Default border color
                                                                    },
                                                                    '&:hover fieldset': {
                                                                        borderColor: '#299257', // Border color on hover
                                                                    },
                                                                    '&.Mui-focused fieldset': {
                                                                        borderColor: '#299257', // Border color when focused
                                                                    },
                                                                },
                                                            }}
                                                        />
                                                    </div>}

                                                <select onChange={(e) => setHeightUnitChange(e.target.value)} className='analytics-weight-unit-select gray_gradient font_size_18 font_family_inter'>
                                                    <option value='metric' selected={heightUnitChange == 'metric'}>cm</option>
                                                    <option value='imperial' selected={heightUnitChange != 'metric'}>feet</option>
                                                </select>
                                            </div>



                                            <div className='flex gap_10 align_center'>
                                                {(heightUnitChange == 'metric' && heightCm) || (heightUnitChange != 'metric' && heightFeet && heightInches) ?
                                                    <div className='flex gap_8 align_center'>
                                                        <div></div>
                                                        <button onClick={updateHeight} className="analytics-weight-edit-save green_gradient white font_weight_600 cursor_pointer">Save</button>
                                                    </div> : null}
                                            </div>
                                        </div>
                                    )

                                else return null_chat(index)
                            }

                            // TDEE Update
                            else if (JSON.parse(msg).role == 'assistant' && JSON.parse(msg).content.includes(change_request.tdee))
                                if (index == messages.length - 1)
                                    return (
                                        <div key={index} className={`ntai-message assistant flex flex_column gap_20`}>
                                            <p className='font_weight_600 font_size_18'>What do you want your daily calorie intake to be?</p>

                                            <div className='flex gap_10 align_center'>
                                                <input type="number" value={inputTdee ? parseInt(inputTdee) : null}
                                                    onChange={(e) => setInputTdee(!e.target.value || e.target.value < 0 ? 0 : (e.target.value < 10000 ? e.target.value : 9999))}
                                                    style={{ width: `4ch` }}
                                                    placeholder={parseInt(activityLevel.tdee)}
                                                    className='analytics-weight-set-input font_family_ovo no_margin analytics-current-weight-p' />

                                                <button onClick={() => updateTdee(inputTdee)} className="analytics-weight-edit-save green_gradient white font_weight_600 cursor_pointer">Update</button>
                                            </div>
                                        </div>
                                    )
                                else return null_chat(index)


                            // Activity Level Update
                            else if (JSON.parse(msg).role == 'assistant' && JSON.parse(msg).content.includes(change_request.activity_level))
                                if (index == messages.length - 1)
                                    return (
                                        <div key={index} className={`ntai-message assistant flex flex_column gap_20`}>
                                            <p className='font_weight_600 font_size_18'>Which best describes your activity level?</p>

                                            <div className="ps_user_info_preferences_items" >
                                                <FormControl component="fieldset">
                                                    <FormGroup row>
                                                        {configs.filter((i) => i.id === 12)[0].options.map((c) => {
                                                            return <FormControlLabel
                                                                key={c.text}
                                                                control={
                                                                    <Checkbox
                                                                        checked={((selecteActivityLevel ? selecteActivityLevel : activityLevel.activity_level) == c.id)}
                                                                        onChange={(e) => setSelectedActivityLevel(c.id)}
                                                                        value={c.id}
                                                                    />
                                                                }
                                                                label={c.text}
                                                            />
                                                        })}
                                                    </FormGroup>
                                                </FormControl>
                                            </div>

                                            {(selecteActivityLevel && selecteActivityLevel != activityLevel.activity_level) ? <button onClick={() => updateActivityLevel()} className="analytics-weight-edit-save green_gradient white font_weight_600 cursor_pointer">Update</button> : null}
                                        </div>
                                    )
                                else return null_chat(index)



                            // Goal Update
                            else if (JSON.parse(msg).role == 'assistant' && JSON.parse(msg).content.includes(change_request.goal))
                                if (index == messages.length - 1)
                                    return (
                                        <div key={index} className={`ntai-message assistant flex flex_column gap_20`}>
                                            <p className='font_weight_600 font_size_18'>Which best describes your health goals?</p>

                                            <div className="ps_user_info_preferences_items">
                                                <FormControl component="fieldset">
                                                    <FormGroup row>
                                                        {
                                                            configs.filter((i) => i.id === 11)[0].options.map((c) => {
                                                                return <FormControlLabel
                                                                    key={c.text}
                                                                    control={
                                                                        <Checkbox
                                                                            checked={selecteGoals.length ? selecteGoals.includes(c.id) : userInfo.planner_goal_fk.includes(c.id)}
                                                                            onChange={(e) => setSelectedGoals((prevGoals) => {
                                                                                if (prevGoals.includes(c.id)) return prevGoals.filter((goal) => goal !== c.id)
                                                                                else return [...prevGoals, c.id]
                                                                            })}
                                                                            value={c.id}
                                                                        />
                                                                    }
                                                                    label={c.text}
                                                                />
                                                            })

                                                        }
                                                    </FormGroup>
                                                </FormControl>
                                            </div>

                                            <center>
                                                {(selecteGoals.length) ? <button onClick={() => updateGoals()} className="analytics-weight-edit-save green_gradient white font_weight_600 cursor_pointer">Update</button> : null}
                                            </center>
                                        </div>
                                    )
                                else return null_chat(index)


                            else {
                                return (
                                    <div key={index} className={`ntai-message ${JSON.parse(msg).role === 'user' ? 'green_gradient user white' : 'assistant gray_scale_1'}`}>
                                        <div className='font_weight_400 font_size_16'>
                                            {formatText(JSON.parse(msg).content)}
                                        </div>
                                    </div>
                                )
                            }
                        })}
                        {/* Update suggested TDEE */}
                        {suggestedTdee ?
                            <div className={`ntai-message assistant flex flex_column gap_20`}>
                                <p className='font_weight_600 font_size_18'>Your suggested daily calorie intake is {suggestedTdee}</p>

                                <div className='flex gap_8 align_center'>
                                    <p className='cursor_pointer' onClick={() => setSuggestedTdee()}>Cancel</p>

                                    <button onClick={() => updateTdee(suggestedTdee)} className="analytics-weight-edit-save green_gradient white font_weight_600 cursor_pointer">Update</button>
                                </div>
                            </div>
                            : null}

                        {responding && (
                            <div className="ntai-message ntai-assistant">
                                <div className='font_weight_400 font_size_16'>
                                    {formatText(aiResponse)}
                                </div>
                            </div>
                        )}
                    </div>

                </div>

                <div className="ntai-chat-input">
                    <input
                        type="text"
                        id="ntai-user-input"
                        placeholder="Type your message..."
                        value={userInput}
                        onChange={handleUserInput}
                        onKeyDown={handleKeyDown}
                    />
                    <button id="ntai-send-button" className='green_gradient' onClick={sendMessage}>
                        <img src={sendImage} alt='Send icon' />
                    </button>
                </div>
            </div>
        </div>
    );
}

export default NutritionistAI;
